import React, { useState,useEffect } from "react";
import Header from '../../layout/header';
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import axios from 'axios'
import ReactPaginate from 'react-paginate';
import NotFoundData from "../../../Images/no-data-found.webp";
import { Dropdown } from 'react-bootstrap';
import *  as Constants from '../contants';

const ReferralsAssigned = ({
    getAllReferrals,
    referralList=[]
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [userId, setUserId] = useState('')
    const [pageNo, setPage] = useState(1)
    const [list,setList]=useState([]);

    useEffect(() => {
        let userId = localStorage.getItem('user_id')
        setUserId(userId)
    }, [userId])

    const onPageChange = async (val) => {
        setIsLoading(true);
        setPage(val?.selected + 1);
        window.localStorage.referralAssignedPage=val?.selected + 1
        if(userId!=''){
            await getAllReferrals(val?.selected + 1, '',[{status:2}]);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        const fetchReferrals = async () => {
            setIsLoading(true);
            let currPage = window.localStorage.referralAssignedPage ? window.localStorage.referralAssignedPage : 1;
            setPage(currPage)
            if(userId!=''){
                const res = await getAllReferrals(currPage, {'assigned_user_id':userId,},[{status:2}]);
                setList(res);
            }
            setIsLoading(false);
        };
    
        fetchReferrals();
    }, [pageNo,getAllReferrals,userId]);

    return (
        <>
          <Loader isLoading={isLoading} />
          <div id="wrapper">
            <DashboardMenu />
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <Header title={'Drop a new Referral'} />
                <div className="container-fluid common-bg">
                    <div className="col-md-6 col-sm-6 d-flex mt-20px">
                        <h1 className="h3 mb-0 text-black-100">Referrals Assigned</h1>
                    </div>
                    <div className="container-fluid bootstrap snippets bg-white py-4 mt-50px" style={{marginTop: 'auto'}}>
                        
                    <div className="row">
                        {list?.data && list?.data.map((referral, index) => (
                                <div className="col-md-4 col-sm-6" key={index}>
                                    <div className="card-big-shadow">
                                        <div className="card card-just-text">
                                            <div className="content">
                                            <h6 className="category mrg-b-12">
                                                <div className={`header-ui-item-opp bg-${referral?.status_colour_class} text-white`}>
                                                    {referral?.status_text}
                                                </div>
                                                </h6>
                                                <div className="row list-view">
                                                    <div className="mb-flex">
                                                        <div className="col-md-6 col-sm-6 no-wrap">
                                                            <i className="fas fa-user"></i>&nbsp;&nbsp;Referred By Name
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 l2">{referral.referred_by_name}</div>
                                                    </div>
                                                    <div className="mb-flex">
                                                        <div className="col-md-6 col-sm-6 no-wrap">
                                                            <i className="fa fa-phone-alt"></i>&nbsp;&nbsp;Referred By Contact
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 l2">{referral.referred_by_contact}</div>
                                                    </div>
                                                    <div className="mb-flex">
                                                        <div className="col-md-6 col-sm-6 no-wrap">
                                                            <i className="fa fa-envelope"></i>&nbsp;&nbsp;Referred By Email
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 l2">{referral.referred_by_email}</div>
                                                    </div>
                                                    <div className="mb-flex">
                                                        <div className="col-md-6 col-sm-6 no-wrap">
                                                            <i className="fa fa-user"></i>&nbsp;&nbsp;Client Name
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 l2">{referral.client_name}</div>
                                                    </div>
                                                    <div className="mb-flex">
                                                        <div className="col-md-6 col-sm-6 no-wrap">
                                                            <i className="fa fa-info-circle"></i>&nbsp;&nbsp;Remarks
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 l2">{referral.remarks||'N/A'}</div>
                                                    </div>
                                                    <div className="mb-flex">
                                                        <div className="col-md-6 col-sm-6 no-wrap">
                                                            <i className="fa fa-id-badge"></i>&nbsp;&nbsp;Lead ID/Account ID
                                                        </div>
                                                        <div className="col-md-6 col-sm-6 l2">{referral.merged_id}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {list?.data && list?.data.length > 0 && (
                                <div className="panel-pagination-col panel-table-pagination">
                                    <ReactPaginate
                                        previousLabel={'<'}
                                        nextLabel={'>'}
                                        breakLabel={'...'}
                                        breakClassName={'break-me'}
                                        pageCount={Math.ceil(list?.total / list?.per_page)}
                                        forcePage={pageNo - 1}
                                        pageRangeDisplayed={4}
                                        onPageChange={onPageChange}
                                        activeClassName={'active'}
                                    />
                                </div>
                            )}
                            {list?.data && list?.data.length === 0 && (
                                <>
                                    <img src={NotFoundData} className="not-found-data" alt="Not Found" />
                                    <div className="text-center" style={{ width: "100%" }}>
                                        Data Not Found
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
};

export default ReferralsAssigned;